module.exports = __webpack_public_path__ + "static/media/stofferingen-36.38e0260e.jpg";